module.exports = __webpack_public_path__ + "static/media/review-image-sannau.7f20822f.png";